import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { errMsg } from "../ui";

/** Every column of one saved call. */
export function CallDetailDialog({ id, onClose }) {
  const [row, setRow] = useState(null);
  useEffect(() => {
    setRow(null);
    if (!id) return;
    api.get(`/usage-charges/calls/${id}`).then(({ data }) => setRow(data))
      .catch((e) => { toast.error(errMsg(e, "Could not load the call")); onClose(); });
  }, [id, onClose]);
  return (
    <Dialog open={!!id} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="uc-call-dialog">
        <DialogHeader><DialogTitle>Call {id}</DialogTitle></DialogHeader>
        {!row ? <Loader2 className="mx-auto my-8 h-5 w-5 animate-spin text-slate-300" /> : (
          <dl className="grid max-h-[65vh] grid-cols-[minmax(0,200px)_1fr] gap-x-4 gap-y-1 overflow-auto text-xs" data-testid="uc-call-fields">
            {Object.entries(row).map(([k, v]) => (
              <div key={k} className="contents"><dt className="truncate text-slate-500" title={k}>{k}</dt>
                <dd className="break-all font-mono text-slate-800">{v === null || v === "" ? <span className="text-slate-300">—</span> : String(v)}</dd></div>))}
          </dl>)}
      </DialogContent>
    </Dialog>
  );
}
